import { render, staticRenderFns } from "./contact-communications.vue?vue&type=template&id=28fca73b&lang=html&"
import script from "./contact-communications.vue?vue&type=script&lang=js&"
export * from "./contact-communications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports